import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const OrderIndex = () => import("@/views/pages/order/Index");
const OrderDetail = () => import("@/views/pages/order/Details");
const BatchIndex = () => import("@/views/pages/batch/Index");
const BatchDetail = () => import("@/views/pages/batch/Details");
const BatchCreate = () => import("@/views/pages/batch/components/createBatch/CreateBatchPanel.vue");

const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");

Vue.use(Router);

export default new Router({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { requiresIsLogin: true },
    },
    {
      path: "/d-order",
      name: "d-order",

    },
    {
      path: "/d-chatbot",
      name: "d-chatbot",

    },
    {
      path: "/",
      redirect: "/batch",
      name: "หน้าแรก",
      component: TheContainer,
      meta: { requiresAuth: true, lv: 1, activeUrl: "/batch" },
      children: [
        {
          path: "batch",
          redirect: "/batch",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "รายการแบทช์คลังสินค้า",
              component: BatchIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/batch",
                lv: 2,
              },
            },
            {
              path: "details/:id",
              name: "รายละเอียดแบทช์คลังสินค้า",
              component: BatchDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/batch",
                lv: 2,
              },
            },
            {
              path: "create-batch/:id",
              name: "รายการธุรกรรมใหม่",
              component: BatchCreate,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/batch",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "order",
          redirect: "/order",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "รายการคำสั่งซื้อ",
              component: OrderIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/batch",
                lv: 2,
              },
            },
            {
              path: "details/:id",
              name: "รายละเอียดคำสั่งซื้อ",
              component: OrderDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/batch",
                lv: 2,
              },
            },
          ],
        },
      ],

      //   {
      //     path: "404",
      //     name: "Page404",
      //     component: Page404,
      //   },
      //   {
      //     path: "500",
      //     name: "Page500",
      //     component: Page500,
      //   },
      // ],
    },
  ],
});
